import DelegationAddRequest, {
  DelegationAddRequestAddressSequenceNode,
  DelegationAddRequestTimezone,
  DelegationAddRequestVehicleType,
} from "../../../api/raily/delegation/add/delegation-add.request";
import Timezone from "../../../types/timezone";
import VehicleType from "../../../types/vehicle-type";
import DelegationAddParams, {
  DelegationAddParamsAddress,
} from "./delegation-add-params";

const createAddress = (
  params: DelegationAddParamsAddress,
): DelegationAddRequestAddressSequenceNode => {
  return {
    displayName: params.displayName,
    lat: params.latitude,
    lon: params.longitude,
    apartmentNumber: params.apartmentNumber,
    houseNumber: params.houseNumber,
    street: params.street,
    time: params.time,
    town: params.town,
    zipCode: params.zipCode,
    distance: params.distance,
  };
};

const createAddressGroup = (
  params: DelegationAddParamsAddress[],
): DelegationAddRequestAddressSequenceNode[] => {
  return params.map(createAddress);
};

const createAddressSequence = (
  params: DelegationAddParamsAddress[][],
): DelegationAddRequestAddressSequenceNode[][] => {
  return params.map(createAddressGroup);
};

const createVehicleType = (
  type: VehicleType,
): DelegationAddRequestVehicleType => {
  switch (type) {
    case VehicleType.CAR_GT_900CM3:
      return DelegationAddRequestVehicleType.CAR_GT_900CM3;
    case VehicleType.CAR_LE_900CM3:
      return DelegationAddRequestVehicleType.CAR_LE_900CM3;
    case VehicleType.COMPANY_OWNED:
      return DelegationAddRequestVehicleType.COMPANY_OWNED;
    case VehicleType.MOPED:
      return DelegationAddRequestVehicleType.MOPED;
    case VehicleType.MOTORCYCLE:
      return DelegationAddRequestVehicleType.MOTORCYCLE;
  }
};

const createVehicleTypes = (
  types: VehicleType[],
): DelegationAddRequestVehicleType[] => {
  return types.map(createVehicleType);
};

const createTimezone = (
  timezone: Timezone | undefined,
): DelegationAddRequestTimezone | undefined => {
  switch (timezone) {
    case Timezone.EUROPE_WARSAW:
      return DelegationAddRequestTimezone.EUROPE_WARSAW;
    case Timezone.UTC:
      return DelegationAddRequestTimezone.UTC;
    default:
      return DelegationAddRequestTimezone.EUROPE_WARSAW;
  }
};

const create = (params: DelegationAddParams): DelegationAddRequest => {
  return {
    workerCompanyUuid: params.workerCompanyUuid,
    workerUuid: params.workerUuid,
    dateFrom: params.dateFrom,
    dateTo: params.dateTo,
    mileagesCost: params.mileagesCost,
    totalDistance: params.totalDistance,
    addressSequence: createAddressSequence(params.addressSequence),
    groupVehicleTypes: createVehicleTypes(params.groupVehicleTypes),
    osrmDistance: params.osrmDistance,
    accommodationBillsCost: params.accommodationBillsCost,
    accommodationCost: params.accommodationCost,
    prepay: params.prepay,
    startedDayDietCost: params.startedDayDietCost,
    wholeDayDietCost: params.wholeDayDietCost,
    localTravelCost: params.localTravelCost,
    oneDayDietCost: params.oneDayDietCost,
    otherExpenses: params.otherExpenses,
    timezone: createTimezone(params.timezone),
  };
};

const delegationAddParamsFactory = {
  create,
};

export default delegationAddParamsFactory;
